export const API_VERSION = 'v2'
export const isDevMode = process.env.NODE_ENV === 'development'
